import React from 'react';
import styled from 'styled-components';
import moment from 'moment';

interface Props {
	billing: any[];
	sendPeriod: (dateRange: { startDate: string, endDate: string }) => void;
	selectedBillingPeriod: any;
	disabled?: boolean;
}

const SelectElement = styled.select`
  background-color: #f6f6f6;
`;

export const BillingPeriodSelect: React.FC < Props > = (props: Props) => {

	const handleBillingSelect = (e: any) => {
		const startDate = e.target.value.substr(0, e.target.value.indexOf('*'));
		const endDate = e.target.value.substr(e.target.value.indexOf('*') + 1, e.target.value.length);
		props.sendPeriod({ startDate, endDate });
	};

	return (
		<div>
			<SelectElement onChange={handleBillingSelect} value={`${props.selectedBillingPeriod.startDate}*${props.selectedBillingPeriod.endDate}`} disabled={props.disabled} >
				{props.billing.map((e, key) => (
					<option key={key} value={`${e.startDate}*${e.endDate}`}>{`${moment(e.startDate).format('DD.MM.YYYY')} - ${moment(e.endDate).format('DD.MM.YYYY')}`}</option>
				))} )
        	</SelectElement>
		</div>
	)
};
